import {
	Button,
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import _ from 'lodash'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RightBox } from '../../components'
import Modal from '../../components/Modal'
import { getEventEx } from '../../store/EventById/selectors'
import { updateOrCreateEventEx } from '../../store/HouseContainer/operations'
import { getActiveSubControl } from '../../store/SubControlById/selectors'
import {
	Control,
	House,
	initEventFan,
	Scenario,
	TimePattern,
} from '../../types'
import EditFanEventForm from './components/EditFanEventForm'

type Props = {
	house: House
	scenario: Scenario
	control: Control
	timePattern: TimePattern
}

function FanManageTab({ scenario, control, timePattern }: Props) {
	const [open, setOpen] = React.useState(false)
	const dispatch = useDispatch()
	const activeSubc = useSelector((s) => getActiveSubControl(s, control))
	const eventEx = useSelector((s) =>
		getEventEx(s, scenario.eventIds, timePattern, activeSubc, initEventFan),
	)
	const enableStyle = eventEx.enabled ? {} : { background: '#ddd' }

	return (
		<Container>
			<div style={{ marginTop: '8px' }}>
				<RightBox>
					<Button variant="outlined" onClick={() => setOpen(true)}>
						<SettingsIcon />
						編集{!eventEx.enabled && '・有効にする'}
					</Button>
				</RightBox>
				{!eventEx.enabled && <Typography>無効です</Typography>}
				<div style={{ ...enableStyle }}>
					<TableContainer component={Paper}>
						<Table style={{ ...enableStyle }}>
							<TableBody>
								<TableRow>
									<TableCell>オン時間</TableCell>
									<TableCell>{eventEx.activeInterval}分</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>オフ時間</TableCell>
									<TableCell>{eventEx.negativeInterval}分</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</div>
			<Modal open={open} closeModal={() => setOpen(false)}>
				<EditFanEventForm
					initialValues={_.omit(
						{
							...eventEx,
							scenarioId: scenario.id,
							timePattern,
							subControlId: activeSubc.id,
						},
						['id'],
					)}
					disabled={false}
					handleSubmit={(field) => {
						dispatch(updateOrCreateEventEx(field, eventEx.id))
						setOpen(false)
					}}
				/>
			</Modal>
		</Container>
	)
}

export default FanManageTab
